import { briefingApi } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export function useBriefs() {
  return useQuery({
    queryKey: ['briefs'],
    queryFn: () => {
      return briefingApi.get('briefs').json();
    },
    initialData: [],
    // staleTime: 1000 * 60 * 60,
  });
}
